import { setup } from 'xstate';

import type { FilingDomainEvent } from '@/features/filing/state/events';
import type { SourceBoxEvent } from './events';

const sourceBoxSetup = setup({
  types: {
    events: {} as SourceBoxEvent | FilingDomainEvent,
  },
});

export const sourceBoxMachine = sourceBoxSetup.createMachine({
  id: 'source-box',
  initial: 'idle',
  states: {
    idle: {
      on: {
        'source-box.observe': 'unavailable',
        'filing.statement-handed-in': 'unavailable',
      },
    },
    unavailable: {
      on: {
        'source-box.observe': 'unavailable',
        'filing.statement-handed-in': 'unavailable',
      },
    },
  },
});
